// Freshchat API docs: https://developers.freshchat.com/web-sdk/#customisation-wgt

const freshChatScriptTagId = 'freshchat-js-sdk'

const translatedContent = {
  get: (locale) => {
    if (['en', 'fr', 'nl'].includes(locale)) {
      return I18n.t('help.freshchat_widget')
    }

    return {}
  },
}

function configureFreshworksChat(onLoadCallback) {
  return () => {
    window.fcWidget.init({
      config: {
        headerProperty: {
          hideChatButton: true,
        },
        content: {
          headers: translatedContent.get(I18n.locale),
        },
      },
      token: 'f2510e46-539e-4f37-92c2-0a16e7b9447c',
      host: 'https://wchat.eu.freshchat.com',
      locale: I18n.locale,
    })

    window.fcWidget.setExternalId(window.freshdeskChatSettings.externalId)
    window.fcWidget.user.setFirstName(window.freshdeskChatSettings.firstName)
    window.fcWidget.user.setEmail(window.freshdeskChatSettings.email)

    if (onLoadCallback && typeof onLoadCallback === 'function') {
      onLoadCallback()
    }
  }
}

export function initializeFreshworksChat(
  onLoadCallback,
  document = window.document,
  tag = freshChatScriptTagId
) {
  window.fcSettings = {
    onInit: function () {
      window.fcWidget.on('widget:opened', function () {
        Silverfin.Spinner.hide()
      })
    },
  }

  const element = document.createElement('script')
  element.id = tag
  element.async = false
  element.src = 'https://wchat.eu.freshchat.com/js/widget.js'
  element.onload = configureFreshworksChat(onLoadCallback)
  document.body.appendChild(element)
}

function flushFreshchat() {
  window.fcWidget = null
  delete window.history.pushState_fc_observer
  delete window.history.replaceState_fc_observer
  /*
   ** The following two lines restore the original values of `pushState` and `replaceState` that
   ** the freshdesk script overwrote. The freshdesk widget doesn't expose an API to
   ** appropriately reverse the changes they did.
   **
   ** The original implementation can't be deleted by accident: If a property with the
   ** same name exists on the object's prototype chain, then, after deletion, the
   ** object will use the property from the prototype chain (in other words, delete only
   ** has an effect on own properties)
   ** (source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete)
   */
  delete window.history.pushState
  delete window.history.replaceState
}

document.addEventListener('turbolinks:load', function () {
  if (document.body.dataset.freshdeskEnabled === 'true') {
    if (window.fcWidget) {
      flushFreshchat()
    }
  }
})

document.addEventListener('turbolinks:before-cache', function () {
  if (document.body.dataset.freshdeskEnabled === 'true') {
    const scriptTag = document.getElementById(freshChatScriptTagId)
    scriptTag?.parentNode?.removeChild(scriptTag)

    // Remove css from the head that will be re-added when loading the widget
    document
      .querySelectorAll(
        'link[href*="wchat.eu.freshchat.com/widget/css/widget.css"]'
      )
      .forEach((e) => e.remove())
    document
      .querySelectorAll(
        'link[href*="wchat.eu.freshchat.com/widget/css/cb.css"]'
      )
      .forEach((e) => e.remove())
  }
})
